'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = function (Placeholder, defaultProps) {
  if ((0, _utils.isString)(defaultProps)) {
    defaultProps = { name: defaultProps };
  }

  var Animation = function (props) {
    var animation = props.animation;

    if ((0, _utils.isString)(animation)) {
      animation = { name: animation };
    }

    var newProps = _extends({}, props, {
      fillerStyle: _extends({}, props.fillerStyle, {
        animationName: _modes.SLIDE,
        animationDelay: '0',
        animationDuration: '0.5s',
        animationDirection: 'normal',
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
      }, (0, _utils.normalizeAnimation)(defaultProps), (0, _utils.normalizeAnimation)(animation))
    });

    return _react2['default'].createElement(Placeholder, newProps);
  };

  Animation.propTypes = {
    fillerStyle: _propTypes2['default'].object,
    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object])
  };

  Animation.defaultProps = {
    fillerStyle: null,
    animation: null
  };

  return Animation;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modes = require('./modes');

var _utils = require('./utils');

require('../style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-hold-animation/lib/HoC.js
// module id = 193
// module chunks = 0